import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './LanguageSwitcher.css';

const LanguageSwitcher = ({ bgColor }) => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="language-switcher">
      <button
        className={`lang-btn ${language === 'he' ? 'active' : ''}`}
        onClick={() => setLanguage('he')}
        style={{ color: bgColor === 'white' ? '#2d2d2d' : 'white' }}
        aria-label="Switch to Hebrew"
      >
        ע
      </button>
      <span className="lang-separator" style={{ color: bgColor === 'white' ? '#2d2d2d' : 'white' }}>|</span>
      <button
        className={`lang-btn ${language === 'en' ? 'active' : ''}`}
        onClick={() => setLanguage('en')}
        style={{ color: bgColor === 'white' ? '#2d2d2d' : 'white' }}
        aria-label="Switch to English"
      >
        En
      </button>
    </div>
  );
};

export default LanguageSwitcher;

